import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ className = '', style = {} }) => {
  const { currentLocale, availableLocales, changeLanguage, getLanguageName, isLoading, t } = useLanguage();

  const handleLanguageChange = (locale) => {
    if (locale !== currentLocale && !isLoading) {
      changeLanguage(locale);
    }
  };

  const getFlag = (locale) => {
    const flags = {
      'nl': '🇳🇱',
      'en': '🇬🇧',
      'fr': '🇫🇷'
    };
    return flags[locale] || '🌐';
  };

  return (
    <div 
      className={`language-selector ${className}`} 
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        ...style
      }}
    >
      {availableLocales.map((locale) => (
        <button
          key={locale}
          onClick={() => handleLanguageChange(locale)}
          disabled={isLoading}
          className={`language-option ${currentLocale === locale ? 'active' : ''}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            padding: '6px 10px',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '20px',
            background: currentLocale === locale 
              ? 'rgba(76, 175, 80, 0.8)' 
              : 'rgba(255,255,255,0.1)',
            color: 'white',
            fontSize: '12px',
            fontWeight: currentLocale === locale ? 'bold' : 'normal',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s ease',
            opacity: isLoading ? 0.6 : 1,
            textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
            backdropFilter: 'blur(5px)'
          }}
          onMouseEnter={(e) => {
            if (!isLoading && currentLocale !== locale) {
              e.target.style.background = 'rgba(255,255,255,0.2)';
              e.target.style.transform = 'scale(1.05)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading && currentLocale !== locale) {
              e.target.style.background = 'rgba(255,255,255,0.1)';
              e.target.style.transform = 'scale(1)';
            }
          }}
          title={getLanguageName(locale)}
        >
          <span style={{ fontSize: '14px' }}>{getFlag(locale)}</span>
          <span>{locale.toUpperCase()}</span>
        </button>
      ))}
      
      {isLoading && (
        <div 
          style={{
            fontSize: '12px',
            color: 'rgba(255,255,255,0.7)',
            fontStyle: 'italic'
          }}
        >
          {t('app.loading')}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;